export type GetHomeMenuDataListRequest = {
  userId?: string;
  dfnSetVerNum?: string;
};
